import { render, staticRenderFns } from "./PlaceZoneBuilder.vue?vue&type=template&id=dc3b7a2c&"
import script from "./PlaceZoneBuilder.vue?vue&type=script&lang=js&"
export * from "./PlaceZoneBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc3b7a2c')) {
      api.createRecord('dc3b7a2c', component.options)
    } else {
      api.reload('dc3b7a2c', component.options)
    }
    module.hot.accept("./PlaceZoneBuilder.vue?vue&type=template&id=dc3b7a2c&", function () {
      api.rerender('dc3b7a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/places/builder/PlaceZoneBuilder.vue"
export default component.exports